import { RequestType } from './types';
import { format } from 'date-fns';

const parceRequest = (data: RequestType) => ({
  status: data!.status || '',
  title: data!.title || '',
  description: data!.essence || '',
  createDate:
    data.date_created && data.date_created.length
      ? `Дата создания ${format(data.date_created, 'DD.MM.YYYY')}`
      : 'Дата создания: не определена',
  startDate:
    data.date_started && data.date_started.length
      ? `Начало работы ${format(data.date_started, 'DD.MM.YYYY')}`
      : 'Начало работы: неизвестно',
  endDate:
    data.date_ended && data.date_ended.length
      ? `Завершен ${format(data.date_ended, 'DD.MM.YYYY')}`
      : '',
});

export default parceRequest;



// WEBPACK FOOTER //
// ./src/services/mentoring/utils/parceRequest.ts